import { StarIcon } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  quote: string;
}
const testimonials: Testimonial[] = [{
  initials: 'CR',
  name: 'Camila R.',
  location: 'Santiago',
  quote: 'Me ordenó por completo la forma de comprar. Dejé de pasar al supermercado “por una cosa” y mi despensa por fin me alcanza toda la semana.'
}, {
  initials: 'FM',
  name: 'Felipe M.',
  location: 'Viña del Mar',
  quote: 'La calculadora fue el golpe de realidad que necesitaba. Ver los gastos hormiga por separado hizo muy fácil saber qué cambiar primero.'
}, {
  initials: 'JC',
  name: 'Javiera C.',
  location: 'Concepción',
  quote: 'El sistema de stockeo me sirvió incluso trabajando desde casa. Tengo opciones listas y ya no termino pidiendo delivery por cansancio.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#1B3022] py-16 px-4" data-id="element-272" data-mp="32frf52b26sap">
      <div className="max-w-6xl mx-auto" data-id="element-273" data-mp="32eg90vu558gf">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-274" data-mp="2v0j3vj58zswm">
          <p className="text-sm font-bold tracking-[0.16em] text-[#C5A059] uppercase mb-3" data-id="element-275" data-mp="2q2hksy7tntl5">
            Experiencias de lectores
          </p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-276" data-mp="34q2nir0sbqsj">
            Un sistema simple para una vida más liviana
          </h2>
          <p className="text-lg text-white/75" data-id="element-277" data-mp="2c2q9544s2pab">
            Personas que viven solas y decidieron ponerle método a sus compras.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-278" data-mp="2756onmhhlg9x">
          {testimonials.map(testimonial => <article key={testimonial.name} className="rounded-2xl border border-[#1B3022]/10 bg-[#F5F2EB] p-7 shadow-sm" data-id="element-279" data-mp="2m2h4t952rabz">
              <div className="flex gap-1 mb-5" aria-label="5 de 5 estrellas" data-id="element-280" data-mp="19vudefzxby0">
                {Array.from({
              length: 5
            }, (_, index) => <StarIcon key={index} className="w-4 h-4 fill-[#C5A059] text-[#C5A059]" aria-hidden="true" data-id="element-281" data-mp="3sgowqlmizh44" />)}
              </div>

              <blockquote className="text-[#3a3a32] leading-relaxed mb-7" data-id="element-282" data-mp="dcyj493brvp3">
                “{testimonial.quote}”
              </blockquote>

              <div className="flex items-center gap-3 border-t border-[#1B3022]/10 pt-5" data-id="element-283" data-mp="ib02yw8krz1m">
                <div className="w-10 h-10 rounded-full bg-[#1B3022] text-white flex items-center justify-center text-sm font-bold" data-id="element-284" data-mp="3gugg1lhk7iaq">
                  {testimonial.initials}
                </div>
                <div data-id="element-285" data-mp="3qrl1tk7htbr0">
                  <p className="font-bold text-[#1B3022] text-sm" data-id="element-286" data-mp="3qr2zq6y5g3b6">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-[#5a5a4f]" data-id="element-287" data-mp="3vko025n7t9dj">{testimonial.location}</p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-6 text-center text-xs text-white/55" data-id="element-288" data-mp="330z4onz11bvs">
          Los resultados pueden variar según los hábitos de compra y la aplicación del protocolo.
        </p>
      </div>
    </section>;
}